import React, { useEffect, useState } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, Users, CalendarDays, LogOut,
  FileText, Building2, Shield, ClipboardList, FolderOpen, Menu, X,
  RefreshCw, // PLENARIUM:RECARREGAR
  Gavel, // PLENARIUM:COMISSOES
  BookOpen // PLENARIUM:CENTRAL_ATAS
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export default function Layout() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  // >>> PLENARIUM:ADMIN_CELULAR
  // No celular o menu lateral vira gaveta. Fecha sozinho ao trocar de tela.
  const [menuAberto, setMenuAberto] = useState(false);
  const local = useLocation();
  useEffect(() => { setMenuAberto(false); }, [local.pathname]);
  // <<< PLENARIUM:ADMIN_CELULAR

  const handleLogout = () => {
    logout();
    navigate('/login/admin');
  };

  const iniciais = usuario?.nome
    ? usuario.nome.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()
    : '?';

  return (
    <div className="layout">

      {/* ── HEADER FIXO PRETO ── */}
      <header className="app-header">
        {/* PLENARIUM:ADMIN_CELULAR - so aparece em tela estreita (index.css) */}
        <button type="button" className="btn-menu-movel" aria-label="Abrir menu" onClick={() => setMenuAberto(v => !v)}>
          {menuAberto ? <X size={20} /> : <Menu size={20} />}
        </button>
        <div className="app-header-brand">
          {!usuario?.superAdmin && usuario?.camara?.logoUrl ? (
            <img
              src={usuario.camara.logoUrl}
              alt="Brasão"
              className="sidebar-brasao"
            />
          ) : (
            <span style={{ fontSize: '1.2rem' }}>🏛️</span>
          )}
          <div className="app-header-brand-text">
            <strong>Plenarium Digital</strong>
            <span>iSolutions</span>
          </div>
        </div>

        <div className="app-header-divider" />

        <div className="app-header-camara">
          {usuario?.superAdmin ? (
            <span>Super Admin</span>
          ) : (
            <span>{usuario?.camara?.nome || 'Painel Administrativo'}</span>
          )}
        </div>

        <div className="app-header-right">
          {usuario?.superAdmin && (
            <div className="super-admin-tag">⭐ Super Admin</div>
          )}
          <div className="app-header-user">
            <div className="app-header-avatar">{iniciais}</div>
            <span>{usuario?.nome}</span>
          </div>
          {/* PLENARIUM:RECARREGAR */}
          <button type="button" title="Recarregar a tela" aria-label="Recarregar a tela" onClick={() => window.location.reload()}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 30, background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 6, color: 'rgba(255,255,255,0.75)', cursor: 'pointer' }}>
            <RefreshCw size={14} />
          </button>
          <button className="btn-header-logout" onClick={handleLogout}>
            <LogOut size={13} /> Sair
          </button>
        </div>
      </header>

      {/* ── SIDEBAR LATERAL ── */}
      {/* PLENARIUM:ADMIN_CELULAR - fundo escuro: tocar fora fecha o menu */}
      <div className={`sidebar-fundo ${menuAberto ? 'aberto' : ''}`} onClick={() => setMenuAberto(false)} />
      <aside className={`sidebar ${menuAberto ? 'aberta' : ''}`}>
        <nav className="sidebar-nav">

          <span className="nav-section-label">Principal</span>

          <NavLink
            to="/"
            end
            className={({ isActive }) => `nav-item ${isActive ? 'ativo' : ''}`}
          >
            <LayoutDashboard size={16} /> Dashboard
          </NavLink>

          {/* Menu do Super Admin */}
          {usuario?.superAdmin && (
            <>
              <span className="nav-section-label" style={{ marginTop: 8 }}>Gestão</span>
              <NavLink
                to="/camaras"
                className={({ isActive }) => `nav-item ${isActive ? 'ativo' : ''}`}
              >
                <Building2 size={16} /> Câmaras
              </NavLink>
              <NavLink
                to="/logs"
                className={({ isActive }) => `nav-item ${isActive ? 'ativo' : ''}`}
              >
                <Shield size={16} /> Auditoria
              </NavLink>
            </>
          )}

          {/* Menu do Admin da Câmara */}
          {!usuario?.superAdmin && (
            <>
              <span className="nav-section-label" style={{ marginTop: 8 }}>Legislativo</span>
              <NavLink
                to="/vereadores"
                className={({ isActive }) => `nav-item ${isActive ? 'ativo' : ''}`}
              >
                <Users size={16} /> Vereadores
              </NavLink>
              <NavLink
                to="/sessoes"
                className={({ isActive }) => `nav-item ${isActive ? 'ativo' : ''}`}
              >
                <CalendarDays size={16} /> Sessões e Pautas
              </NavLink>
              <NavLink
                to="/projetos"
                className={({ isActive }) => `nav-item ${isActive ? 'ativo' : ''}`}
              >
                <FolderOpen size={16} /> Trâmite Legislativo
              </NavLink>
              {/* PLENARIUM:COMISSOES */}
              <NavLink
                to="/comissoes"
                className={({ isActive }) => `nav-item ${isActive ? 'ativo' : ''}`}
              >
                <Gavel size={16} /> Comissões
              </NavLink>
              {/* PLENARIUM:CENTRAL_DOCUMENTOS */}
              <NavLink
                to="/documentos"
                className={({ isActive }) => `nav-item ${isActive ? 'ativo' : ''}`}
              >
                <FileText size={16} /> Central de Documentos
              </NavLink>
              <NavLink
                to="/protocolos"
                className={({ isActive }) => `nav-item ${isActive ? 'ativo' : ''}`}
              >
                <ClipboardList size={16} /> Protocolo Digital
              </NavLink>

              <span className="nav-section-label" style={{ marginTop: 8 }}>Relatórios</span>
              <NavLink
                to="/relatorios"
                className={({ isActive }) => `nav-item ${isActive ? 'ativo' : ''}`}
              >
                <FileText size={16} /> Relatórios
              </NavLink>
              {/* PLENARIUM:CENTRAL_ATAS */}
              <NavLink
                to="/atas"
                className={({ isActive }) => `nav-item ${isActive ? 'ativo' : ''}`}
              >
                <BookOpen size={16} /> Central de Atas
              </NavLink>
              <NavLink
                to="/logs"
                className={({ isActive }) => `nav-item ${isActive ? 'ativo' : ''}`}
              >
                <Shield size={16} /> Auditoria
              </NavLink>
            </>
          )}
        </nav>
      </aside>

      {/* ── CONTEÚDO PRINCIPAL ── */}
      <main className="main-content">
        <Outlet />
      </main>

    </div>
  );
}
